var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 85,
    viewBox: "0 0 133 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M66.3984 84.2132C103.069 84.2132 132.797 81.4311 132.797 77.9992C132.797 74.5673 103.069 71.7852 66.3984 71.7852C29.7276 71.7852 0 74.5673 0 77.9992C0 81.4311 29.7276 84.2132 66.3984 84.2132Z",
    fill: "#F3F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6167 29.2704C88.7684 19.2237 73.1379 23.7188 73.0804 23.7353C68.582 29.4978 62.6951 38.4249 59.9663 48.4825C55.2335 65.9266 61.0481 74.7164 61.0481 74.7164C61.0481 74.7164 64.2934 81.4778 83.2253 79.5846C89.6829 78.939 95.5554 79.1679 100.514 79.0615C108.908 61.9692 100.476 39.3357 94.6167 29.2704Z",
    fill: "#98C6CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.626 65.7934C117.032 50.5129 102.951 23.6968 92.9616 16.9766H78.9407C78.9407 16.9766 76.384 19.5051 73.0803 23.7372C73.1379 23.7207 88.7684 19.2256 94.6167 29.2722C100.476 39.3375 108.907 61.9711 100.514 79.063C110.139 78.8568 116.318 77.3858 116.626 65.7934Z",
    fill: "#69ABB9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9409 16.9783C78.9409 16.9783 67.1988 -0.231709 75.4604 0.0529478C83.7221 0.337972 82.1924 3.32907 87.3731 2.75939C92.5534 2.18971 93.5508 -1.51377 99.5334 0.765324C105.516 3.04441 91.6991 18.5707 91.6991 18.5707L78.9409 16.9783Z",
    fill: "#69ABB9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.25 40.2509C92.3524 40.2509 93.2544 39.3488 93.2544 38.2465C93.2544 37.1442 92.3524 36.2422 91.25 36.2422H79.9254H75.376C74.2737 36.2422 73.3717 37.1442 73.3717 38.2465C73.3717 39.3488 74.2737 40.2509 75.376 40.2509H79.9258C81.8699 40.2509 83.5335 41.3935 84.295 43.0571H75.3958C74.2935 43.0571 73.3915 43.9591 73.3915 45.0614C73.3915 46.1637 74.2935 47.0658 75.3958 47.0658H84.295C83.5335 48.7095 81.8699 49.872 79.9258 49.872H75.376C74.5543 49.872 73.8126 50.3731 73.5118 51.1346C73.211 51.8961 73.3915 52.778 73.9927 53.3392L85.3372 64.0623C85.7179 64.4229 86.219 64.6033 86.7201 64.6033C87.2612 64.6033 87.7824 64.3829 88.1834 63.9819C88.9449 63.1801 88.9049 61.9174 88.103 61.1559L80.4063 53.8803C84.3548 53.6598 87.6218 50.8338 88.5036 47.0856H91.2497C92.352 47.0856 93.254 46.1835 93.254 45.0812C93.254 43.9789 92.352 43.0769 91.2497 43.0769H88.5036C88.263 42.0747 87.862 41.1125 87.3012 40.2707H91.2497V40.2509H91.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0459 79.3556C86.0459 79.3556 74.0287 79.3556 70.9066 72.7891C70.9066 72.7891 70.3212 77.9562 75.0771 79.8831C75.0771 79.8831 83.5229 80.1296 86.0459 79.3556Z",
    fill: "#69ABB9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4001 13.0476C90.4001 13.0476 94.3366 7.12223 95.3963 0.0285488C95.3963 0.0285488 103.516 -0.725647 100.514 5.51883C100.514 5.51883 99.2179 9.62765 94.2195 15.5368L90.4001 13.0476Z",
    fill: "#4C9BAC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0561 17.6251C78.6166 17.6328 78.183 17.4226 77.9252 17.0286C77.5257 16.4197 77.6919 15.6035 78.2997 15.2014C78.5744 15.0195 85.148 10.7805 94.2885 14.0419C94.9763 14.2873 95.3351 15.0437 95.0897 15.7319C94.8446 16.4193 94.0893 16.7784 93.3997 16.533C85.55 13.7334 79.9871 17.2597 79.7541 17.4108C79.5381 17.551 79.2964 17.6207 79.0561 17.6251Z",
    fill: "#F7A47A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.069 19.7692C95.9241 19.7692 95.777 19.7454 95.6324 19.6948C84.1097 15.6656 76.7277 19.5675 76.6551 19.6078C76.0149 19.9571 75.2109 19.7208 74.8609 19.0789C74.5113 18.4373 74.7483 17.6343 75.3899 17.2847C75.7314 17.0987 83.8881 12.7874 96.5055 17.1978C97.1951 17.4388 97.5586 18.1934 97.3176 18.883C97.1272 19.4281 96.6155 19.7692 96.069 19.7692Z",
    fill: "#F7A47A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1561 29.3853C87.9841 29.3853 87.8095 29.3515 87.6411 29.2804C86.9687 28.9957 86.654 28.2195 86.9386 27.5467C90.3182 19.562 87.4203 17.9814 87.3902 17.9663C87.4181 17.9799 87.2515 17.8816 87.2515 17.8816L88.44 15.5391C88.5886 15.6003 89.9158 16.1909 90.6817 18.0529C91.7107 20.5558 91.2712 24.0971 89.3747 28.5775C89.1609 29.0823 88.6711 29.3853 88.1561 29.3853Z",
    fill: "#F7A47A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3683 33.1511C98.6449 33.2487 97.9795 32.7417 97.8812 32.0191C97.8779 31.9949 97.5346 29.5745 96.2958 26.8043C94.6891 23.2101 92.4052 20.7388 89.5081 19.4586C88.8401 19.1633 88.5378 18.3823 88.8327 17.7139C89.128 17.046 89.9083 16.7441 90.5773 17.0386C98.9369 20.7326 100.442 31.2186 100.502 31.6632C100.6 32.3877 100.092 33.0535 99.3683 33.1511Z",
    fill: "#F7A47A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4165 71.7535C13.4165 71.7535 34.0772 70.5767 54.738 71.7535H13.4165Z",
    fill: "#FFDD82"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4163 71.7524V77.2617H54.7377V71.7524H13.4163Z",
    fill: "#FFAD0D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1727_18117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 42,
    height: 7
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4163 71.7563V77.2656H54.7377V71.7563H13.4163Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1727_18117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2759 78.9996V70.8945",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4341 78.8394V70.7344",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5925 78.6792V70.5742",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7512 78.3394V70.2344",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9094 78.6011V70.4961",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0676 78.6011V70.4961",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2261 79.0113V70.9062",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3845 78.6011V70.4961",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8596 78.9683V70.8633",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5427 78.6011V70.4961",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0181 78.5933V70.4883",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7012 78.7574V70.6523",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1763 78.4914V70.3867",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6418 65.3629C11.6418 65.3629 32.3026 64.1861 52.9633 65.3629H11.6418Z",
    fill: "#FFDD82"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6418 65.3617V70.8711H52.9633V65.3617H11.6418Z",
    fill: "#FFAD0D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1727_18117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 65,
    width: 42,
    height: 6
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6421 65.3578V70.8672H52.9636V65.3578H11.6421Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1727_18117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5012 72.6089V64.5039",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6594 72.4484V64.3438",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8176 72.2886V64.1836",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9761 71.9488V63.8438",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1343 72.2105V64.1055",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2927 72.2105V64.1055",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4512 72.6206V64.5156",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 72.2105V64.1055",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0847 72.5777V64.4727",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7678 72.2105V64.1055",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2429 72.2027V64.0977",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.926 72.3667V64.2617",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4014 72.1011V63.9961",
    stroke: "#FFDD82",
    strokeWidth: 1.8694,
    strokeMiterlimit: 10
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8585 79.4343C58.2734 79.4343 66.7163 70.9914 66.7163 60.5765C66.7163 50.1617 58.2734 41.7188 47.8585 41.7188C37.4437 41.7188 29.0007 50.1617 29.0007 60.5765C29.0007 70.9914 37.4437 79.4343 47.8585 79.4343Z",
    fill: "#FFAD0D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0416 79.4343C57.4565 79.4343 65.8994 70.9914 65.8994 60.5765C65.8994 50.1617 57.4565 41.7188 47.0416 41.7188C36.6268 41.7188 28.1838 50.1617 28.1838 60.5765C28.1838 70.9914 36.6268 79.4343 47.0416 79.4343Z",
    fill: "#FFDD82"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0416 79.4343C57.4565 79.4343 65.8994 70.9914 65.8994 60.5765C65.8994 50.1617 57.4565 41.7188 47.0416 41.7188C36.6268 41.7188 28.1838 50.1617 28.1838 60.5765C28.1838 70.9914 36.6268 79.4343 47.0416 79.4343Z",
    fill: "#FFDD82"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0416 75.7824C55.4395 75.7824 62.2473 68.9746 62.2473 60.5768C62.2473 52.1789 55.4395 45.3711 47.0416 45.3711C38.6437 45.3711 31.8359 52.1789 31.8359 60.5768C31.8359 68.9746 38.6437 75.7824 47.0416 75.7824Z",
    fill: "#FFAD0D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0415 45.3711C46.9299 45.3711 46.8192 45.3729 46.708 45.3755C54.9517 45.553 61.5802 52.2905 61.5802 60.5768C61.5802 68.863 54.9517 75.6009 46.708 75.778C46.8188 75.7806 46.9299 75.7824 47.0415 75.7824C55.4392 75.7824 62.2471 68.9745 62.2471 60.5768C62.2471 52.179 55.4392 45.3711 47.0415 45.3711Z",
    fill: "#FFDD82"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8568 60.5768C32.8568 52.35 39.3907 45.6499 47.5519 45.3806C47.3824 45.3751 47.2122 45.3711 47.0416 45.3711C38.6439 45.3711 31.8359 52.179 31.8359 60.5768C31.8359 68.9745 38.6439 75.7824 47.0416 75.7824C47.2125 75.7824 47.3824 75.7788 47.5519 75.7729C39.3907 75.5033 32.8568 68.8036 32.8568 60.5768Z",
    fill: "#F7A47A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4053 54.3699C49.9446 55.1252 50.3492 55.9612 50.592 56.8782H53.37L52.2912 60.1147H50.7538C50.2953 63.4591 47.9758 66.0753 44.6858 66.5335L49.6874 73.5908H45.7499L40.7754 66.6145V63.378H43.4723C45.4411 63.378 47.1134 62.0024 47.5177 60.1415H40.0469L41.1257 56.905H47.2748C46.6545 55.4216 45.1711 54.3967 43.4719 54.3967H40.0469L41.1257 51.1602H53.37L52.2912 54.3967H49.4053V54.3699Z",
    fill: "#F7A47A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1237 53.698C50.663 54.4533 51.0676 55.2893 51.3104 56.2064H54.0884L53.0095 59.4429H51.4722C51.0136 62.7872 48.6942 65.4034 45.4038 65.8616L50.4054 72.919H46.4679L41.4934 65.9427V62.7062H44.1903C46.1591 62.7062 47.8314 61.3306 48.2357 59.4697H40.7649L41.8437 56.2331H47.9928C47.3725 54.7497 45.8891 53.7248 44.1899 53.7248H40.7649L41.8437 50.4883H54.088L53.0092 53.7248H50.1234L50.1237 53.698Z",
    fill: "#FFDD82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.6e7b0debe8339e163630d0991f346075.svg";
export { ForwardRef as ReactComponent };